import {
    deleteDataApi,
    getDataApi,
    postDataApi,
    putDataApi,
} from '../utils/fech-api';

const BASE_URL_EMISSIONS = '/api/emissions';
export const BASE_URL_EMISSION_Manage = '/api/admin/emissions';

// Fetch all emissions
export const fetchEmissions = async (params = {}, headers = {}) => {
    return await getDataApi(BASE_URL_EMISSIONS, {...headers, Accept: 'application/ld+json',}, params);
};

// Fetch a single emission by ID
export const fetchEmissionById = (emissionId, headers = {}) => {
    return getDataApi(`${BASE_URL_EMISSIONS}/${emissionId}`, headers);
};

// Create a new emission
export const createEmission = (postData, headers = {}) => {
    return postDataApi(BASE_URL_EMISSION_Manage, postData, headers);
};

// Update an emission (PUT request)
export const updateEmission = (postId, updatedData, headers = {}) => {
    return putDataApi(`${BASE_URL_EMISSION_Manage}/${postId}`, updatedData, headers);
};


// Delete an emission
export const deleteEmission = (emissionId, headers = {}, params = {}) => {
    return deleteDataApi(`${BASE_URL_EMISSION_Manage}/${emissionId}`, headers, params);
};
